import React from 'react';

import { cn } from '@epoch-ui/lib/utils';

import { Select, SelectTrigger, SelectValue } from './select';

interface SelectInputProps extends React.ComponentProps<typeof Select> {
  className?: string;
  error?: boolean;
  placeholder?: string;
}

const SelectInput = React.forwardRef<HTMLButtonElement, SelectInputProps>(
  ({ className, children, error, placeholder, ...rootProps }, ref) => (
    <Select {...rootProps}>
      <SelectTrigger
        ref={ref}
        className={cn(
          'tw-h-12',
          'data-[placeholder]:tw-text-muted-foreground',
          error &&
            'tw-border-destructive-foreground tw-ring-destructive-foreground focus:tw-border-destructive-foreground',
          className
        )}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      {children}
    </Select>
  )
);

export { SelectInput };
